import { render, staticRenderFns } from "./CompanyNonConformityDetail.vue?vue&type=template&id=91a8788a&scoped=true&"
import script from "./CompanyNonConformityDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyNonConformityDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNonConformityDetail.vue?vue&type=style&index=0&id=91a8788a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a8788a",
  null
  
)

export default component.exports